const AuthButton = ({ className = '', disabled, children, ...props }) => {
  return (
    <button
            {...props}
            className={
                `flex items-center justify-center w-full px-10 py-4 text-base font-medium text-center text-white transition-all duration-500 ease-in-out delay-150 transform bg-[conic-gradient(at_bottom_right,_var(--tw-gradient-stops))] from-indigo-300 via-slate-900 to-indigo-300 rounded-xl hover:bg-[conic-gradient(at_bottom,_var(--tw-gradient-stops))] hover:from-indigo-300 hover:via-slate-900 hover:to-indigo-300 hover:text-neutral-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-400 ${
                    disabled && 'opacity-25'
                } ` + className
            }
            disabled={disabled}
        >
            {children}
    </button>
  )
}

export default AuthButton
